import { ALL_BRANDS } from "@/data/categories";

export default function BrandsMarquee() {
  const doubled = [...ALL_BRANDS, ...ALL_BRANDS];
  return (
    <section className="py-14 border-y border-slate-200 bg-slate-50 overflow-hidden" data-testid="brands-marquee">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8 mb-6 flex items-baseline justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500">Global Brand Partners</div>
          <h3 className="font-display text-2xl md:text-3xl font-bold mt-1">Sourced from <span className="gfe-gradient-text">80+ trusted OEMs</span></h3>
        </div>
        <div className="hidden md:block text-sm text-slate-500">Genuine · Certified · Traceable</div>
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-50 to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-50 to-transparent z-10" />
        <div className="marquee-track py-4">
          {doubled.map((b, i) => (
            <div key={i} className="shrink-0 px-6 py-3 rounded-full bg-white border border-slate-200 text-sm font-semibold text-slate-700 shadow-sm">
              {b}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
